import { Badge } from '@acin/ui-core';
import styled from 'styled-components';

// This named style should be the wrapper for the component i.e. the module
export const StatusBadge = styled(Badge)``;
